import { createAction, props } from '@ngrx/store';
import { AppModule } from '@app/enums';
export const loadTimeseriesInfoApis = createAction(
  '[Timeseries] Load All',
  props<{ module: AppModule.ETF | AppModule.INSURANCE | AppModule.OCIO | AppModule.OSMA }>()
);

export const loadTimeseriesInfoApisSuccess = createAction(
  '[Timeseries] Load Success',
  props<{ data: Record<string, any> }>()
);

export const loadTimeseriesInfoApisFailure = createAction(
  '[Timeseries] Load Failure',
  props<{ error: unknown }>()
);

export const updateTimeseries = createAction(
  '[Time Seies]  Item',
  props<{
    list: any[];
    range: any;
    startDate: any;
    endDate: any;
    chartLabels: any;
    apiType: string;
  }>()
);
